module.exports = __webpack_public_path__ + "static/media/IMG_1639.153e9518.jpg";